import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { cn } from '../../lib/cn';

interface CampoImpostazioneProps {
    /** Etichetta mostrata sopra la casella. */
    etichetta: string;
    valore: string;
    onChange: (valore: string) => void;
    /** Riga di spiegazione sotto la casella, per i campi non ovvi. */
    aiuto?: string;
    segnaposto?: string;
    tipo?: 'text' | 'email' | 'tel' | 'number' | 'url';
    /** Messaggio di errore: quando c'e', il bordo diventa rosso. */
    errore?: string;
    disabilitato?: boolean;
    className?: string;
}

/**
 * Una casella della pagina Impostazioni: etichetta, casella, aiuto, errore.
 * Esiste perche' la sola scheda "Dati azienda" ha venti campi identici nella
 * forma: scriverli a mano venti volte vuol dire venti occasioni di sbagliare
 * una classe e ritrovarsi il modulo storto in un punto solo.
 */
export function CampoImpostazione({
    etichetta,
    valore,
    onChange,
    aiuto,
    segnaposto,
    tipo = 'text',
    errore,
    disabilitato,
    className
}: CampoImpostazioneProps) {
    const id = React.useId();

    return (
        <div className={cn('space-y-1.5', className)}>
            <Label htmlFor={id} className="text-sm font-medium text-gray-700">
                {etichetta}
            </Label>
            <Input
                id={id}
                type={tipo}
                value={valore}
                placeholder={segnaposto}
                disabled={disabilitato}
                onChange={(e) => onChange(e.target.value)}
                aria-invalid={Boolean(errore)}
                aria-describedby={aiuto || errore ? `${id}-aiuto` : undefined}
                className={cn(errore && 'border-red-400 focus-visible:ring-red-400')}
            />
            {(errore || aiuto) && (
                <p
                    id={`${id}-aiuto`}
                    className={cn('text-xs leading-snug', errore ? 'text-red-600' : 'text-gray-500')}
                >
                    {errore || aiuto}
                </p>
            )}
        </div>
    );
}

export default CampoImpostazione;
